module.exports = __webpack_public_path__ + "static/media/84.44d00f6d.jpg";